import { render, staticRenderFns } from "./CommunityUnitTree.vue?vue&type=template&id=3b16f5ba&scoped=true"
import script from "./CommunityUnitTree.vue?vue&type=script&lang=js"
export * from "./CommunityUnitTree.vue?vue&type=script&lang=js"
import style0 from "./CommunityUnitTree.vue?vue&type=style&index=0&id=3b16f5ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16f5ba",
  null
  
)

export default component.exports